import Touchid from './Touchid';

export default Touchid;
